(() => {
  const rootSelector = "[data-cfm-v27]";
  const cardSelector = "[data-cfm-v27-card]";
  const stateByRoot = new WeakMap();

  const sortCards = (root, value) => {
    const grid = root.querySelector("[data-cfm-v27-grid]");
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(cardSelector));
    cards.sort((left, right) => {
      if (value === "title-ascending") {
        return left.dataset.cfmV27Title.localeCompare(right.dataset.cfmV27Title);
      }
      if (value === "price-ascending") {
        return Number(left.dataset.cfmV27Price) - Number(right.dataset.cfmV27Price)
          || Number(left.dataset.cfmV27Order) - Number(right.dataset.cfmV27Order);
      }
      if (value === "price-descending") {
        return Number(right.dataset.cfmV27Price) - Number(left.dataset.cfmV27Price)
          || Number(left.dataset.cfmV27Order) - Number(right.dataset.cfmV27Order);
      }
      return Number(left.dataset.cfmV27Order) - Number(right.dataset.cfmV27Order);
    });

    cards.forEach((card) => grid.appendChild(card));
  };

  const update = (root) => {
    const state = stateByRoot.get(root);
    if (!state) return;

    root.toggleAttribute("data-cfm-v27-curated-layout", state.filter === "all" && state.sort === "featured");
    sortCards(root, state.sort);

    const hasDedicatedSetGallery = Boolean(root.querySelector(".cfm-trios-r1"));
    let visibleCount = 0;
    root.querySelectorAll(cardSelector).forEach((card) => {
      const isRepeatedSet = hasDedicatedSetGallery && card.dataset.cfmV27Family === "set";
      const matchesFilter = state.filter === "all" || card.dataset.cfmV27Family === state.filter;
      const visible = !isRepeatedSet && matchesFilter;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    const status = root.querySelector("[data-cfm-v27-status]");
    if (status) {
      const noun = visibleCount === 1 ? root.dataset.cfmV27StatusSingular : root.dataset.cfmV27StatusPlural;
      status.textContent = `${visibleCount} ${noun} ${root.dataset.cfmV27StatusSuffix}`;
    }
  };

  const initialize = (root) => {
    if (stateByRoot.has(root)) return;

    const state = { filter: "all", sort: "featured" };
    stateByRoot.set(root, state);

    root.querySelectorAll("[data-cfm-v27-filter]").forEach((button) => {
      button.addEventListener("click", () => {
        state.filter = button.dataset.cfmV27Filter || "all";
        root.querySelectorAll("[data-cfm-v27-filter]").forEach((candidate) => {
          const active = candidate.dataset.cfmV27Filter === state.filter;
          candidate.classList.toggle("is-active", active);
          candidate.setAttribute("aria-pressed", active ? "true" : "false");
        });

        const mobileLabel = root.querySelector("[data-cfm-v27-mobile-filter-label]");
        if (mobileLabel) {
          mobileLabel.textContent = button.dataset.cfmV27FilterLabel || button.textContent.trim();
        }

        const mobileFilter = root.querySelector("[data-cfm-v27-mobile-filter]");
        if (mobileFilter) mobileFilter.open = false;
        update(root);
      });
    });

    const mobileFilter = root.querySelector("[data-cfm-v27-mobile-filter]");
    if (mobileFilter) {
      document.addEventListener("click", (event) => {
        if (mobileFilter.open && !mobileFilter.contains(event.target)) {
          mobileFilter.open = false;
        }
      });

      mobileFilter.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          mobileFilter.open = false;
          mobileFilter.querySelector("summary")?.focus();
        }
      });
    }

    const sort = root.querySelector("[data-cfm-v27-sort]");
    if (sort) {
      sort.addEventListener("change", () => {
        state.sort = sort.value;
        update(root);
      });
    }

    update(root);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(initialize);
  };

  document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }
})();
